const state = {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {
      // nickname: "",
      // department: { name: "" }
    }
  };
  
  const mutations = {
    USER_INFO(state, val) {
      state.userInfo = val;
      sessionStorage.setItem("userInfo", JSON.stringify(val));
    }
  };
  
  const actions = {
    userInfo({ commit }, val) {
      commit("USER_INFO", val);
    }
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  